import Dayjs from 'dayjs';
import { orderBy } from 'lodash-es';
import type { MagicSchoolDetail } from '~/api';

export const judgeStatus = ($dayjs: typeof Dayjs, card: MagicSchoolDetail) => {
  const now = $dayjs();
  if (now.isBefore($dayjs(card.start_time))) {
    return 2; // 直播前
  }
  if (now.isAfter($dayjs(card.end_time))) {
    return 1; // 直播后
  }
  return 3; // 直播中
};

export const getLiveList = ($dayjs: typeof Dayjs, list: MagicSchoolDetail[]) => {
  return orderBy(
    list.map(item => {
      return {
        ...item,
        status: judgeStatus($dayjs, item),
      };
    }),
    ['status', 'rank', 'start_time'],
    ['desc', 'asc', 'desc'],
  );
};
